import { RefObject, useEffect, useState } from 'react'

export const useContainerSize = (ref: RefObject<HTMLElement>) => {
  const [size, setSize] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const element = ref.current
    if (!element) return

    // Only update state when dimensions actually changed to avoid
    // unnecessary re-renders from frequent ResizeObserver callbacks.
    const updateSize = () => {
      const { width, height } = element.getBoundingClientRect()
      setSize((prev) =>
        prev.width === width && prev.height === height
          ? prev
          : { width, height }
      )
    }

    updateSize()

    // jsdom (Jest) doesn't support ResizeObserver. Fall back to
    // window resize events so tests don't crash and the hook
    // still functions in environments without ResizeObserver.
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', updateSize)
      return () => window.removeEventListener('resize', updateSize)
    }

    const observer = new ResizeObserver(updateSize)
    observer.observe(element)

    return () => {
      observer.disconnect()
    }
  }, [ref])

  return size
}
